/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CreateLocalClientBodyType = (typeof CreateLocalClientBodyType)[keyof typeof CreateLocalClientBodyType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateLocalClientBodyType = {
  local: "local",
} as const;
